const e="md-ripple{mix-blend-mode:var(--cds-menu-item-blend-mode)}";export{e as default};
